import React from 'react';

function Model() {
  return (

    <div className="main-model">
      <div className="model-wrng">
        <header className="header-models">
          <h1>Por favor fazer login</h1>
        </header>
        <main className="model-content">
          <p className="model-text">
            Para continuar usando a aplicação faça login
            <a href="/">aqui</a>
          </p>
        </main>
      </div>
    </div>
  );
}

export default Model;
